import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n        width: 50%;\n        // padding: 0.1rem 2rem;\n      "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n        padding: 0.75rem 2rem;\n      "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      font-size: 13px;\n      line-height: 13px;\n      & span {\n        font-size: 13px;\n        line-height: 13px;\n      }\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      padding: 0.75rem 2rem;\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    justify-content: space-between;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  text-align: right;\n  padding: 0 1.875rem 2rem;\n  display: flex;\n  justify-content: ", ";\n  max-width: ", ";\n  width: ", ";\n  margin: ", ";\n  ", "\n  button {\n    font-size: 16px;\n    line-height: 16px;\n    padding: 1.5rem 1.5rem;\n    ", "\n    & span {\n      font-size: 16px;\n      line-height: 16px;\n    }\n\n    ", "\n\n    &:last-child {\n      margin-left: 2rem;\n      padding: 1.5rem 3.5rem;\n      ", "\n      ", "\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { media, styled } from "@styles";
export var Footer = styled.div(_templateObject(), function (props) {
  return props.deleteModal ? "space-between" : "flex-end";
}, function (props) {
  return props.deleteModal ? "426px" : "none";
}, function (props) {
  return props.deleteModal ? "100%" : "auto";
}, function (props) {
  return props.deleteModal ? "0 auto" : "0";
}, media.smallScreen(_templateObject2()), media.xxLargeScreen(_templateObject3()), media.xxLargeScreen(_templateObject4()), media.xxLargeScreen(_templateObject5()), media.smallScreen(_templateObject6()));